'use client';

import {
  BaseDialogType,
  defaultDialogMap,
  DialogContentMap
} from '@ianesthesie-kit/redux';
import {
  ActivatePendingPatientDialog,
  AddDocumentDialog,
  CreateFollowUpEventDialog,
  NlpCategorySelectDialog,
  RegistrationSuccessDialog,
  UploadDocumentQrDialog,
  ConventionStatusDialog,
  SnippetFormDialog,
  PlanFollowUpDialog,
  RequiredFieldsDialog
} from '@/components/dialogs';
import { TextAreaDialog } from '@/components/dialogs/TextAreaDialog';
import { ConfirmationPromiseDialog } from '@/components/dialogs/ConfirmationPromiseDialog';
import { DeleteMediumWarningDialog } from '@/components/dialogs/DeleteMediumWarningDialog';

enum AppSpecificDialogType {
  ADD_DOCUMENT = 'ADD_DOCUMENT',
  TEXT_AREA = 'TEXT_AREA',
  NLP_CATEGORY_SELECT = 'NLP_CATEGORY_SELECT',
  UPLOAD_QR = 'UPLOAD_QR',
  ACTIVATE_PENDING_PATIENT = 'ACTIVATE_PENDING_PATIENT',
  REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS',
  CONFIRMATION_PROMISE = 'CONFIRMATION_PROMISE',
  CREATE_FOLLOW_UP_EVENT = 'CREATE_FOLLOW_UP_EVENT',
  MUTE_DELETE_MEDIUM_WARNING = 'MUTE_DELETE_MEDIUM_WARNING',
  CONVENTION_STATUS_SETUP = 'CONVENTION_STATUS_SETUP',
  MAGIC_KEYBOARD_SNIPPET_FORM = 'MAGIC_KEYBOARD_SNIPPET_FORM',
  PLAN_FOLLOW_UP = 'PLAN_FOLLOW_UP',
  REQUIRED_FIELDS = 'REQUIRED_FIELDS'
}

export type AppDialogType = AppSpecificDialogType | BaseDialogType;
export const AppDialogType = {
  ...BaseDialogType,
  ...AppSpecificDialogType
};

export const appDialogMap: DialogContentMap<
  AppSpecificDialogType & BaseDialogType
> = {
  ...defaultDialogMap,
  [AppSpecificDialogType.ADD_DOCUMENT]: AddDocumentDialog,
  [AppSpecificDialogType.TEXT_AREA]: TextAreaDialog,
  [AppSpecificDialogType.NLP_CATEGORY_SELECT]: NlpCategorySelectDialog,
  [AppSpecificDialogType.UPLOAD_QR]: UploadDocumentQrDialog,
  [AppSpecificDialogType.REGISTRATION_SUCCESS]: RegistrationSuccessDialog,
  [AppSpecificDialogType.ACTIVATE_PENDING_PATIENT]:
    ActivatePendingPatientDialog,
  [AppSpecificDialogType.CONFIRMATION_PROMISE]: ConfirmationPromiseDialog,
  [AppSpecificDialogType.CREATE_FOLLOW_UP_EVENT]: CreateFollowUpEventDialog,
  [AppSpecificDialogType.MUTE_DELETE_MEDIUM_WARNING]: DeleteMediumWarningDialog,
  [AppSpecificDialogType.CONVENTION_STATUS_SETUP]: ConventionStatusDialog,
  [AppSpecificDialogType.MAGIC_KEYBOARD_SNIPPET_FORM]: SnippetFormDialog,
  [AppSpecificDialogType.PLAN_FOLLOW_UP]: PlanFollowUpDialog,
  [AppSpecificDialogType.REQUIRED_FIELDS]: RequiredFieldsDialog
};
